import React from 'react'

const Diplomatura = () => {
    return (
        <div className='text-left text-justify container fondotransparente p-5' >
<center ><h1 className='p-5 botonbordeazul text-white px-5 mx-5 py-3'>Diplomatura Universitaria en Innovación Tecnológica Y Organizacional en Gestión de Juegos de Azar</h1></center>

<center><h3 className='p-3'>Segunda Edición. 
</h3></center>
          

            <img src="./noticias/img/diplomatura1.jpg" className="centrar img-fluid my-3"/>

            <p>Una formación universitaria única para la profesionalización del sector de juegos de azar de Argentina y la región, que aporta:

Los conceptos generales sobre el proceso de transformación tecnológica y las habilidades requeridas en el uso de las TICs. 

La mirada integral sobre los desafíos, oportunidades y modalidades organizacionales y tecnológicas en gestión de juegos de azar.

La exploración de los debates y las tendencias de las tecnologías digitales, las oportunidades y los desafíos que plantea la revolución digital.

El marco conceptual integral y multidisciplinario para el abordaje del impacto de las TIC en el sector público y en la gestión de juegos de azar.

En suma, mediante la comprensión del funcionamiento de los principales desarrollos digitales, procura dotar de una visión global del conjunto de herramientas en el sector público y en la gestión de juegos de azar.</p>

<ul >
                    <li className='p-1'>INICIO: 21 de junio de 2023.</li>
                    <li className='p-1'>MODALIDAD: Online sincrónico.</li>
                    <li className='p-1'>DURACIÓN: 3 meses.</li>

                    <br />
                </ul>

            <p>En su primera edición en 2022  la Diplomatura posibilitó que cerca de 30 profesionales del sector de nuestro país y otros países de la región, accedan a nuevos contenidos, temáticas, metodologías de trabajo y actualizaciones tecnológicas relacionadas al sector de juegos de azar.

La segunda edición de la Diplomatura Universitaria en Innovación Tecnológica y Organizacional en Gestión de Juegos de Azar, gestionada por ALEA y la Universidad de San Martín, ofrece a través de cinco módulos de contenidos, los conceptos básicos y las herramientas principales referidas al proceso de transformación tecnológica y la gestión de juegos de azar.</p>

<ul >
                    <li className='p-1'>Tecnologías aplicadas a gestión de juegos de azar.</li>
                    <li className='p-1'>Tecnologías disruptivas: Big Data, Inteligencia Artificial, Blockchain e Internet de las cosas.</li>
                    <li className='p-1'>Innovaciones para control y fiscalización de juegos de azar en entornos virtuales.</li>
                    <li className='p-1'>Gestión de la calidad y tecnológica</li>
                    <li className='p-1'>Gestión de Proyectos.</li>
                    <li className='p-1'>Herramientas para la adaptación de organizaciones públicas y privadas de juegos de azar a los nuevos procesos tecnológicos.</li>
                    <li className='p-1'>El conocimiento académico, sectorial y profesional en diálogo e intercambio con representantes de los organismos reguladores y/o operadores privados de juegos de azar.</li>
                    <li className='p-1'>Análisis multidisciplinario sobre la revolución digital, los desafíos y oportunidades, las modalidades organizacionales y tecnológicas en la gestión de juegos de azar.</li>
                    <li className='p-1'>Tecnologías disruptivas, gestión de la calidad y tecnológica, gestión de proyectos y de tecnologías aplicadas a juegos de azar, innovación para el control y fiscalización de juegos de azar en entornos virtuales.</li>

                    <br />
                </ul>
            <p>Dirigida a: profesionales, funcionarios públicos, empresarios, integrantes de empresas operadoras y, en general, a personas interesadas en profundizar su conocimiento sobre el uso de las innovaciones digitales y herramientas para adaptarse al proceso de transformación tecnológica, de Argentina y la región.</p>
            <p>Admisión y cupo: Para ingresar a la Diploma se deberá acreditar nivel terciario o de grado. El cupo máximo es de 40 estudiantes.</p>
            <p>Metodología y carga horaria: La modalidad es virtual y se realiza en el Campus Virtual de la Universidad Nacional de San Martín. La carga horaria total es de 60 horas, distribuidas en 5 módulos, de 12 horas cada uno. </p>
            <p>Diploma: Se otorgará el Certificado de Estudios “Diplomado Universitario en Innovación Tecnológica y Organizacional en Gestión de Juegos de Azar” a quienes acrediten la aprobación de todos los trabajos prácticos de las asignaturas, del trabajo integrador final y la asistencia requerida (75%).</p>
            
            <ul >
                    <li className='p-1'>Duración: 3 meses</li>
                    <li className='p-1'>Costo:  $100.000 (pesos cien mil), incluye matrícula, cursada y diploma.</li>
                    <li className='p-1'>Cierre de Inscripciones: 9 de Junio de 2023.</li>
                    <li className='p-1'>Formulario de pre-inscripción: </li> <a href="https://docs.google.com/forms/d/e/1FAIpQLSeMIhA1lLp13CE8L688EpJu4jWUO_u7seiYhQRpAO5EnvPuAg/viewform" target="_blank">Acceder</a>
                    <li className='p-1'>Consultas: formacion@alea.org.ar</li>
                    
                    </ul>
                    <br />

        </div>
    )
}

export default Diplomatura